import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { useThemeUI } from "theme-ui";

import { BackButton } from "./styled";

import LoginCard from "components/ui/LoginCard";
import H2 from "components/typography/H2";
import P from "components/typography/P";
import TextInput from "components/forms/TextInput";
import BasicButton from "components/forms/BasicButton";
import { BackArrowIcon } from "components/svg";
import { useToast } from "components/toast";

import { sendForgotPassword } from "api/Auth";

const ForgotPassword = () => {
  const themeContext = useThemeUI();
  const { theme } = themeContext;
  const toast = useToast();
  const navigate = useNavigate();
  const [responseErrors,setResponseErrors] = useState(false);

  const _onSubmit = async (values: any, actions: any) => {
    try {
      const res = await sendForgotPassword({ email : values.email });   
      if(res?.success){
        toast.add(res?.message,"#667E4E");
        navigate("/login");
      }else{        
        toast.add(res?.message,"#A60000");
        setResponseErrors(true);
      }
    } catch(err: any){      
      toast.add(err.message || "Error requesting password reset.","#A60000");
      setResponseErrors(true);
    }
  };

  const ResetSchema = Yup.object().shape({
    email: Yup.string().email("Invalid email").required("This field is required."),
  });


  useEffect(() => { 
    document.title = process.env.REACT_APP_NAME + " | Forgot Password"; 
  }, []);

  return (
    <LoginCard>
      <H2 textAlign="center" fontWeight="500" marginBottom="2rem">
        Forgot Password?
      </H2>
      <P color={theme?.colors?.black} textAlign={"center"} fontFamily={"Poppins"} fontSize={"14px"}>
        No worries. We will send you reset instructions.
      </P>
      <Formik initialValues={{ email: "" }} onSubmit={_onSubmit} validationSchema={ResetSchema}>
        {({ isSubmitting, errors, values, submitCount, setFieldValue }) => {
          return (
            <Form noValidate autoComplete="off">
              <TextInput 
                name="email" 
                label="Email" 
                value={values.email}
                onChange={(val: any) => setFieldValue("email",val)}
                $errors={errors.email && submitCount > 0 ? errors.email : null} 
                $responseErrors={responseErrors}
              />
              <BasicButton                      
                type="submit"                      
                $submitting={isSubmitting}
                styles={{ width: "100%" }}
                $loadingColor="#fff"
                keepText={false}
              >Reset Password</BasicButton>
            </Form>
          );
        }}
      </Formik>
      <BackButton>
        <Link to={"/login"}>
          <BackArrowIcon fill={theme?.colors?.body} width={"20px"} height={"auto"} margin={"0 10px 0 0"} />
          <span>Back to Login</span>
        </Link>
      </BackButton>      
    </LoginCard>
  );
};

export default ForgotPassword;
